import React, { useEffect, useMemo, useState } from 'react';
import Skeleton from 'react-loading-skeleton';
import 'react-loading-skeleton/dist/skeleton.css';
import Carousel from '../carousel';
import { StylePackData, StylePackGroup, StylePackItemTypes } from './style-packs-tab';
import { ContentTemplate } from '../../stores/reducers/generate-content';
import { STATIC_ASSET_URL } from '../../utils/content-templates';
import StylePackItem from './style-pack-item';
import Icon, { COLORS, ICONS } from '../general-components/icon';

// TODO: need to add more definition to this
export interface StylePackProps {
	id: string;
	name: string;
	locked?: boolean;
	content: StylePackGroup[];
	setStylePackInfo: (stylePackInfo: StylePackData, id: string) => void;
	filter?: string;
	forceLoadImmediate?: boolean;
}

export function getAssetURL(url: string) {
	return url.replace('ASSET_URL', STATIC_ASSET_URL);
}

export default function StylePack(props: StylePackProps) {
	const {
		id,
		name,
		content = [],
		locked = false,
		setStylePackInfo,
		filter,
	} = props;

	function clickViewStyle() {
		setStylePackInfo({
			id,
			name,
			locked,
			stylePack: content,
		}, '');
	}

	function itemClicked(item: any) {
		setStylePackInfo({
			id,
			name,
			locked,
			stylePack: content,
		}, item.id);
	}

	const templates: ContentTemplate[] = useMemo(() => {
		const data: ContentTemplate[] = [];
		content.forEach((item) => {
			if (filter && item.type !== filter) {
				return;
			}
			data.push(...item.templates);
		});
		return data;
	}, [content, filter]);

	const [drawerOpening, setDrawerOpening] = useState(!props.forceLoadImmediate);

	useEffect(() => {
		setTimeout(() => {
			setDrawerOpening(false);
		}, 250);
	}, []);

	if (templates.length === 0) {
		return <></>;
	}

	return (
		<div
			className="style-pack"
			data-testid="style-pack"
			key={`style-pack-filter-${id}`}
		>
			<div
				className="style-pack-header"
				data-testid="style-pack-header"
			>
				{drawerOpening
					? <Skeleton width={80} height={17} style={{ marginRight: '255px' }}/>
					: <div
						className="style-pack-header-title"
						data-testid="style-pack-header-title"
					>
						{name}
					</div>
				}
				{drawerOpening
					? <Skeleton width={40} height={17} style={{ alignSelf: 'end' }} />
					: <div
						className="style-pack-view-style"
						data-testid="style-pack-view-style"
						onClick={clickViewStyle}
					>
						<div>
							{filter ? 'View Style' : 'Details'}
						</div>
						<div className="style-pack-view-style-arrow">
							<Icon
								name={ICONS.ARROW_RIGHT}
								size={12}
								color={COLORS.TEXT_GRAY_400}
							/>
						</div>
					</div>
				}
			</div>
			{
				filter ? (
					templates.map((item) => (
						<StylePackItem
							key={`style-pack-filtered-item${item.id}`}
							item={item}
							type={StylePackItemTypes.Info}
						/>
					))
				) : (
					<Carousel
						id={id}
						list={templates}
						onClick={itemClicked}
						drawerOpening={drawerOpening}
					/>
				)
			}
		</div>
	);
}
